const INITIAL_STATE = {user:{}}
const LoginLogout = (state = INITIAL_STATE, action) => {
    switch(action.type){
        case "LOG_IN":
            return {
                ...state,
                user: action.payload
            }
        case "LOG_OUT":
            return INITIAL_STATE; //Always return the initial state
        default:
            return state
    }
}

export default LoginLogout;